export const YEAR_OF_COLLABORATION = "academicCollaboration";
export const GEO_REGION_ID = "geoRegionId";
export const SCHOOL_NAME = "schoolName";
export const ACCOUNT_TYPE = "accountType";
export const SCHOOL_TIER = "schoolTier";
export const STATE = "state";
export const CITY = "city";
export const SKU = "sku";
export const NO_OF_WORK_STATIONS = "noOfWorkStations";
export const NO_OF_FACULTY_DAYS = "noOfFacultyDays";